/* eslint-disable react/prop-types */
import React from 'react';

import BaseButton from './Base';
import IconButton from './Icon';
import NativeIconButton from './NativeIcon';

export const ButtonColors = {
  PRIMARY: 'primary',
  ERROR: 'error',
  DEFAULT: 'default',
  LINK: 'link',
  BLUE: 'blue',
};

const Button = (props) => {
  const { type = 'base', children, buttonProps } = props;

  if (type === 'base') {
    return (
      <BaseButton {...buttonProps} buttonColors={ButtonColors}>
        {children}
      </BaseButton>
    );
  }
  if (type === 'icon') {
    return (
      <IconButton {...buttonProps} buttonColors={ButtonColors}>
        {children}
      </IconButton>
    );
  }
  if (type === 'native-icon') {
    return <NativeIconButton {...buttonProps} />;
  }

  return '';
};

export default Button;
